import React from 'react';
import { Button } from './Button';
import { X, RefreshCw } from 'lucide-react';

interface UpdateNotificationProps {
  isVisible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}

export const UpdateNotification: React.FC<UpdateNotificationProps> = ({
  isVisible,
  onUpdate,
  onDismiss
}) => {
  if (!isVisible) return null;

  return (
    <div className="fixed top-4 right-4 z-50 max-w-sm bg-slate-800 border border-slate-700 rounded-lg shadow-lg p-4 animate-in fade-in slide-in-from-top-2 duration-300">
      <div className="flex items-start gap-3">
        <div className="flex-shrink-0 w-8 h-8 bg-orange-500/20 rounded-full flex items-center justify-center">
          <RefreshCw className="w-4 h-4 text-orange-400" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h3 className="text-sm font-semibold text-slate-100 mb-1">
            New Version Available
          </h3>
          <p className="text-xs text-slate-400 mb-3">
            A new version of Politheon is ready. Update now for the latest features and improvements.
          </p>
          
          <div className="flex gap-2">
            <Button
              onClick={onUpdate}
              size="sm"
              className="bg-orange-500 hover:bg-orange-600 text-white text-xs px-3 py-1.5 h-auto"
            >
              Update Now
            </Button>
            <Button
              onClick={onDismiss}
              variant="outline"
              size="sm"
              className="text-slate-400 hover:text-slate-200 hover:bg-slate-700/50 border-slate-600 bg-transparent text-xs px-3 py-1.5 h-auto"
            >
              Later
            </Button>
          </div>
        </div>
        
        <button
          onClick={onDismiss}
          className="flex-shrink-0 w-5 h-5 text-slate-400 hover:text-slate-200 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
